'use client'

import { StepperButton } from '@/components/ui/stepper-button'

interface VariantQuantityInputProps {
  quantity: number
  min: number
  max: number
  step: number
  mode: 'cut' | 'roll'
  unitDisplay: string
  onQuantityChange: (qty: number) => void
}

function getUnitSuffix(mode: 'cut' | 'roll', quantity: number, unitDisplay: string): string {
  if (mode === 'cut') {
    return unitDisplay
  }
  return quantity === 1 ? 'roll' : 'rolls'
}

export function VariantQuantityInput({
  quantity,
  min,
  max,
  step,
  mode,
  unitDisplay,
  onQuantityChange,
}: VariantQuantityInputProps) {
  const unitSuffix = getUnitSuffix(mode, quantity, unitDisplay)

  // These were HeroUI outline icon buttons carrying the `minus`/`plus` icons,
  // which are duotone circle glyphs: a circle inside a round button, stroke at
  // half opacity, on paper. They read as two grey dots rather than controls.
  return (
    <div className="flex items-center gap-2">
      <StepperButton
        direction="decrease"
        aria-label="Decrease quantity"
        disabled={quantity <= min}
        onClick={() => onQuantityChange(quantity - step)}
      />
      <span className="w-24 text-center text-sm font-semibold text-foreground">
        {quantity} {unitSuffix}
      </span>
      <StepperButton
        direction="increase"
        aria-label="Increase quantity"
        disabled={quantity >= max}
        onClick={() => onQuantityChange(quantity + step)}
      />
    </div>
  )
}
